module.exports = __webpack_public_path__ + "static/img/pic2.0f024ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case3/pic2.jpg
// module id = TwKu
// module chunks = 1